import React, { Component } from 'react';

import { 
  Card,
  CardHeader,
  CardContent,
  Divider,
  Typography,
  TextField,
  MenuItem
} from '@mui/material';

// import TableView Component
import DTable from "components/DataTables/DTable";

// services
import { fetchRevenuesByHatcheries, fetchRevenuesByHatcheriesCount } from 'services/transactions';
import { fetchAllSpecies } from 'services/species-details';
import { getServerOrCurrentDateTime } from 'services/utils';

var fields = [{
  name : 'name', 
  label : 'Hatchery Name',
  type : 'string',
  properties : [{required : true}],
  actions : ['index']
}, {
  name : 'CAARegistrationNumber', 
  label : 'CAA Number',
  type : 'string',
  properties : [{required : true}],
  actions : ['index']
}, {
  name : 'state', 
  label : 'State',
  type : 'string',
  properties : [{required : true}],
  actions : ['index']
}, {
  name : 'district', 
  label : 'District',
  type : 'string',
  properties : [{required : true}],
  actions : ['index']
}, {
  name : 'permittedSpeciesId',
  label : 'Species Type',
  type: 'select',
  selectOptions : {},
  properties: [{required:true}],
  actions: ['index']
}, {
  name : 'bookingCount', 
  label : 'Total Transactions',
  type : 'number',
  properties : [{required : true}],
  actions : ['index']
}, {
  name : 'totalAmount', 
  label : 'Total Amount (Rs)',
  type : 'number',
  properties : [{required : true}],
  actions : ['index']
}];

export default class TopRevenuesCard extends Component {
  
  constructor (props) {
    super(props);
    this.state = {
      fyear : null,
      currentYear : null,
      hatcheries : [], count : 0
    };
  }
  
  async componentDidMount () {
    try {
      const currentDateTime = await getServerOrCurrentDateTime();
      const currentYear = currentDateTime.getFullYear();
      const fyear = currentDateTime.getMonth() < 3 ? (currentYear - 1) : currentYear;
      this.firstDay = new Date(fyear + '-04-01').toISOString();
      this.lastDay = new Date((parseInt(fyear) + 1) +  '-03-31').toISOString();
      this.setState({ fyear, currentYear });

      let species = await fetchAllSpecies({page : 1, per_page : -1, sort : 'id:ASC'});
      fields[4].selectOptions = {};
      species.data.map ( s => fields[4].selectOptions[s.id] = s.name);
      await this.fetchData();
      
    } catch (error) {
      console.log(error);
    }
  }
  
  fetchData = async () => {
    try {
      let count = await fetchRevenuesByHatcheriesCount({
        fromDate : this.firstDay, 
        toDate : this.lastDay,
        state : 'ALL',
        district : 'ALL'
      });
      let hatcheries = await fetchRevenuesByHatcheries({
        fromDate : this.firstDay, 
        toDate : this.lastDay,
        state : 'ALL',
        district : 'ALL'
      });
      
      hatcheries.data.map ( d => {
        if (d.license) {
          d.CAARegistrationNumber = d.license.CAARegistrationNumber;
        }
        return d;
      });
      
      this.setState({hatcheries : hatcheries.data, count: count.data});
    } catch(error) {
      console.log(error);
    }
  }
  
  handleYearSelect = async (value) => {

    if (value == this.state.fyear) return;

    this.firstDay = new Date(value + '-04-01').toISOString();
    this.lastDay = new Date((value + 1) +  '-03-31').toISOString();
    
    await this.fetchData();
    this.setState({fyear : value});
  }

  render() {
    
    const currentYear = this.state.currentYear;
    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    const filterValues = currentYear
      ? range(currentYear - 10, currentYear + 5, 1).map(year => ({'id' : year, 'value' : `FY ${year} - ${year+1}`}))
      : [];

    return (<Card sx={{ height: '400', p:2 }} {...this.props} >
      <CardHeader 
        title="Top Hatcheries By Revenues"
        action={(
            <TextField
              id="year"
              label="Select FY"
              name="year"
              fullWidth
              select
              type='text'
              value={this.state.fyear}
              onChange={e => {this.handleYearSelect(e.target.value)}}
              margin="normal"
              variant="standard"
            >
            {
              filterValues.map ((opt, i) => {
                return (<MenuItem key={i} value={opt.id}>{opt.value}</MenuItem>);
              })
            }
            </TextField>
        )}
      />
      <Divider />
      <CardContent>
      {
        this.state.hatcheries.length > 0 &&  
        <DTable
          columns = {fields}
          rowsPerPage={this.state.count}
          dataTotal={this.state.count}
          data={this.state.hatcheries}
          page={1}
          multiDeleteEnabled={false}
        />
      }
      </CardContent>
    </Card>)
  }
}
